<template>
  <div id="faq">
    <div class="ContentContainer">
      <button
        class="btn-expand btn btn-secondary"
        @click="allExpanded = !allExpanded"
      >
        {{ allExpanded ? this.$t("FAQ.collapse") : this.$t("FAQ.expand") }}
      </button>
      <h1 class="heading-lined mb-5">FAQ</h1>
      <ExpandingFaqItem
        class="faq w-100"
        v-for="index in faqsIndexes"
        :key="'FaqItem' + index"
        :allExpanded="allExpanded"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import ExpandingFaqItem from "../ExpandingFaqItem";
import { EN } from "@/plugins/messages/en";

export default {
  metaInfo: {
    title: "FAQ CoinTrackr",
  },
  components: {
    ExpandingFaqItem,
  },
  data() {
    const faqsIndexes = Object.keys(EN.FAQ)
      .filter((v) => !isNaN(v))
      .map((v) => parseInt(v));
    return {
      allExpanded: false,
      faqsIndexes,
    };
  },
};
</script>

<style lang="scss" scoped>
.btn-expand {
  position: relative;
  z-index: 1;

  float: right;
  padding: 12px 20px;

  font-size: 16px;
  border-radius: 4px;
  box-shadow: none;
}
</style>
